import { Buffer } from 'buffer';
export const getBrowserDetail = () => {
  try {
    const userAgent = navigator.userAgent.toLocaleLowerCase()
    let b_version = ''
    if (userAgent.includes('firefox/')) {
      b_version = userAgent.split('firefox/')[1]
    } else if (userAgent.includes('edg/')) {
      b_version = userAgent.split('edg/')[1]
    } else if (userAgent.includes('chrome/')) {
      b_version = userAgent.split('chrome/')[1].split(' ')[0]
    } else if (userAgent.includes('safari/') && !userAgent.includes('chrome/')) {
      // Safari
      b_version = userAgent.split('version/')[1].split(' ')[0]
    }
    return { version: b_version }
  } catch (error) {
    return {}
  }
}


export const encodeBase64 = (data) => {
  return Buffer.from(data).toString('base64');
}
export const decodeBase64 = (data) => {
  return Buffer.from(data, 'base64').toString('ascii');
}
export const getTruncatedAddress = (str) => {
  if (str && str !== '') {
    return str?.slice(0, 5) + str?.slice(-8).replace(/.(?=...)/g, '*')
  }
  return ''
}
export const jwtToJson = (token) => {
  const base64Url = token?.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  const payload = JSON.parse(jsonPayload)
  return payload
}

export function isEmpty(variable){
  if(typeof variable === 'undefined') return true;
  if(variable === null) return true;
  if(typeof variable === 'string' && variable.length === 0) return true;

  return false;

}

export function notEmpty(variable){
  return !isEmpty(variable);
}